import Webcam from 'react-webcam';
import {useFaceDetection} from "react-use-face-detection";
import FaceDetection from '@mediapipe/face_detection';
import { Camera } from '@mediapipe/camera_utils';
import React, {useEffect, useRef, useState} from "react";
import * as actionCreators from "../../store/Action";
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import Visitor_Upload from "../../assets/img/visitor_upload/upload.svg";
import {MDBModalBody, MDBModalHeader} from "mdbreact";
import {Col, Row} from "reactstrap";
import {Button as SementicBtn} from "semantic-ui-react";
import WebCameraWithFR from "./WebCameraWithFR/WebCameraWithFR";

const VisitorPhotoUploadWithFR = (props) => {

  const [modal,setModal] = useState(false);
  const [screenshot,setScreenshot] = useState('');
  const [defaultImage,setDefaultImage] = useState(true);
  const [visitorImage,setVisitorImage] = useState(false);
  const [facingFront,setFacingFront] = useState(true);
  const [isOpen,setIsOpen] = useState(false);
  const webcam = useRef(null);
  const [mounted,setMounted] = useState(false);

  const screenshotHandler = () => {
    let img = webcam.current.getScreenshot();
    setScreenshot(img);
    setModal(false);
    setIsOpen(true);
  }

  useEffect(()=>{
    console.log("load...", props.defaultOpen)
    setModal(props.defaultOpen ? true : false)
  },[])

  const toggle = () => {

  }

  const modalHandler = () => {
    setModal(true);
  }

  const handleFacingMode = () => {
    setFacingFront(!facingFront);
  }

  const imageUpload = (img) => {
    setDefaultImage(false);
    setVisitorImage(true);
    setModal(false);
    setIsOpen(false);
    props.screenshotHandler(img);
  }

  const retakeImage = (condition) => {
    setIsOpen(!condition);
    setModal(condition);
  }

  useEffect(()=>{
      props.screenshot? setModal(false) : setModal(true);
  },[props.screenshot]);

  return (
    <div className="previewComponent">
      {
        modal ?
          <div className={"visitor-image-modal"} isOpen={true} toggle={toggle} size="md" centered={true} style={props.style}>
            {/*<MDBModalHeader className={"title"} toggle={()=>setModal(false)}>
              Get Visitor Image
            </MDBModalHeader>*/}

            <MDBModalBody style={{ padding: '0px' }}>
              <Webcam
                forceScreenshotSourceSize={true}
                mirrored={false}
                imageSmoothing={true}
                screenshotQuality={100}
                onUserMediaError={() => {}}
                onUserMedia={() => {}}
                videoConstraints={{facingMode: facingFront ? "user" : { exact: "environment" }}}
                style={{ width: '100%'}}
                audio={false}
                screenshotFormat="image/jpeg"
                ref={webcam}
              />

              <Row>
                <Col className={"align-center"} style={{ marginTop: "2vh" }}>
                  <SementicBtn style={props.isSignUp ? isSignUp : { width: "38%" }} className={props.isSignUp ? "" : "px-5 search-visitor-btn"}
                               onClick={screenshotHandler}
                  >Capture</SementicBtn>
                  <SementicBtn style={props.isSignUp ? isSignUp : { height:'100%', marginLeft:'10px' }} icon='sync'
                               onClick={handleFacingMode}
                  />
                </Col>
              </Row>
              <br/>
            </MDBModalBody>
          </div>
          : null
      }
      <form
      >
        <input className="fileInput"
               type="file"
               accept="image/png, image/jpeg"
               style={{
                 display: 'none',
                 cursor: 'pointer',
                 zIndex: '1',
                 position: 'absolute',
                 marginTop: '0%',
                 opacity: '0',
                 width: '200px',
                 height: '150px',
               }}

        />
      </form>
      {!modal && props.screenshot && <label
        onClick={modalHandler}
        className="imgPreview" style={{
        textAlign: 'center',
        boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.1)',
        backgroundColor: props.white ? '#00ff51' : '#414141',
        background: 'transparent',
        width: '200px',
        height: '150px',
        marginBottom: '34px'
      }}>
        {
          defaultImage && props.screenshot === '' ?
            <div className="previewText"
                 style={props.image ? isImage : isNotImage}
            >
              <img style={props.image ? isImageTag : isNotImageTag}
                   src={props.image ? props.image : Visitor_Upload}/>
            </div>
            : null
        }

        {
          props.screenshot ?
            <img src={props.screenshot} style={{
              width: '200px',
              height: '150px',
              objectFit: 'scale-down',
              // border: '1px #9a9a9a dotted',
              boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.161)',
              cursor: 'pointer'
            }}/>
            : null
        }
      </label>}
      {
        isOpen &&
        <WebCameraWithFR screenshot={screenshot} isOpen={isOpen} imageUpload={imageUpload} retakeImage={retakeImage}/>
      }
    </div>
  );
};

let isImageTag = {
  height: '200px',
  width: '150px',
  objectFit: 'contain'
};

let isNotImageTag = {
  height: '45%',
};


let isImage = {
  width: '200px',
  height: '150px',
  color: 'white',
  // border: '1px #9a9a9a dotted',
  boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.161)',
  cursor: 'pointer'
};
let isNotImage = {
  width: '200px',
  height: '150px',
  color: 'white',
  paddingTop: '30%',
  // border: '1px #9a9a9a dotted',
  boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.161)',
  cursor: 'pointer'
};

let isSignUp = {
  background: 'linear-gradient(271.79deg, #2B2666 0%, #7C3476 100%)',
  color: 'white',
  marginBottom: '2px'
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  all_available_card: state.reception_SheduleMeetingReducer.all_available_card,
});

const mapDispatchToProps = (dispatch) => {
  return {
    imageUploaderHandler: (image) => dispatch(actionCreators.imageUploaderHandler(image)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // all available cards
    receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(VisitorPhotoUploadWithFR);
